export default __webpack_public_path__ + "static/media/005-haunted house.192af675.svg";